document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  if (!window.gsap || !window.ScrollTrigger) return;

  document.querySelectorAll(".section").forEach(group => {
  // Animate children inside each .gsap-fadeup group
  const groups = document.querySelectorAll(".gsap-fadeup");

  groups.forEach((group) => {
    // Animate inner children
    const innerItems = group.querySelectorAll(".group-block-content > *");

    if (innerItems.length > 0) {
      gsap.fromTo(
        innerItems,
        { autoAlpha: 0, y: 50 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: group,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }
    });

    // Animate elements with .gsap-fadeup themselves
    const fadeItems = document.querySelectorAll(".gsap-fadeup");

    if (fadeItems.length > 0) {
      gsap.fromTo(
        fadeItems,
        { autoAlpha: 0, y: 50 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: fadeItems[0], // or use each element individually if needed
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }


    
    // --- GSAP Zoom In Animation ---
    const itemsImgs = group.querySelectorAll(".gsap-zoomin");
    // Check if the NodeList is not empty
    if (itemsImgs.length > 0) {
      gsap.fromTo(
        itemsImgs,
        { autoAlpha: 0, y: 0, scale: 0.9 },
        {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: group,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        }
      );
    }
    });

    // Images parallax
    gsap.utils.toArray('.images-parallax').forEach(container => {
    const img = container.querySelector('img');

    // Read single attribute (default 20 if missing)
    const val = parseFloat(container.dataset.parallaxMove) || 20;

    // Increase the height of the img
    const extraHeight = (img.offsetHeight * (val / 100)) * 2; 
    // img.style.height = (img.offsetHeight + extraHeight) + "px";

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        scrub: true,
        pin: false,
      }
    });

    tl.fromTo(img, 
      { yPercent: -val, ease: 'none' }, 
      { yPercent: val, ease: 'none' }
    );
  });

  document.querySelectorAll('.product-details ul li').forEach(li => {
    li.textContent = li.textContent.replace(/^\s*-\s*/, '');
});

if (window.innerWidth > 750) {
  // Run only on the custom jewelry page
  if (document.body.classList.contains('template-index')) {

    // Find the outer Shopify section wrappers for both target sections
    const inspiredWrapper = document.querySelector('.journal-marquee')?.closest('.shopify-section');
    const marqueeWrapper = document.querySelector('.blog-tabbing-main')?.closest('.shopify-section');

    if (inspiredWrapper && marqueeWrapper) {
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-blog-marquee';

      // Insert the wrapper before the first section
      inspiredWrapper.parentNode.insertBefore(wrapper, inspiredWrapper);

      // Move both section wrappers into the new wrapper
      wrapper.appendChild(inspiredWrapper);
      wrapper.appendChild(marqueeWrapper);
    }
  }


    // Run only on the custom jewelry page
  if (document.body.classList.contains('template-page-about')) {

    // Find the outer Shopify section wrappers for both target sections
    const collabcontent = document.querySelector('.join-us-marquee')?.closest('.shopify-section');
    const collabmarquee = document.querySelector('.about-explore-section')?.closest('.shopify-section');

    if (collabcontent && collabmarquee) {
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'about-section-wrapper';

      // Insert the wrapper before the first section
      collabcontent.parentNode.insertBefore(wrapper, collabcontent);

      // Move both section wrappers into the new wrapper
      wrapper.appendChild(collabcontent);
      wrapper.appendChild(collabmarquee);
    }
  }

      // Run only on the custom jewelry page
  if (document.body.classList.contains('template-collection-monochrome')) {

    // Find the outer Shopify section wrappers for both target sections
    const monochromecontent = document.querySelector('.why-monochrome')?.closest('.shopify-section.section-wrapper');
    const monochromemarquee = document.querySelector('.monochrome-marquee')?.closest('.shopify-section');

    if (monochromecontent && monochromemarquee) {
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'monochrome-section-wrapper';

      // Insert the wrapper before the first section
      monochromecontent.parentNode.insertBefore(wrapper, monochromecontent);

      // Move both section wrappers into the new wrapper
      wrapper.appendChild(monochromecontent);
      wrapper.appendChild(monochromemarquee);
    }
  }
 } 



});